import { forwardRef } from "react";
import { TermsAndConditionsCompany } from "@clubofcode/ui";
import { LegalLayout } from "~/components/Layout";
import { Link } from "~/components/Link";

const TermsAndConditionsBusinessPage = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <LegalLayout>
      <TermsAndConditionsCompany ref={ref} Link={Link} />
    </LegalLayout>
  );
});

TermsAndConditionsBusinessPage.displayName = "TermsAndConditionsBusinessPage";
export default TermsAndConditionsBusinessPage;
